module.exports = __webpack_public_path__ + "static/portfolio_gallery_22-d41af582a5826bb0a06178d66e061cdf.jpg";